import type { BuiltinRoleId, RoleOption } from "../../shared/rbac/roles";
import type { ScopeKind } from "../../shared/rbac/permissions";

const DEFAULT_ROLE: Record<ScopeKind, BuiltinRoleId | undefined> = {
  space: "space_editor",
  connected_app: "connected_app_user",
  skill: "skill_user",
  network: "network_user",
  user_group: "user_group_member",
  service_account: "service_account_viewer",
  oidc_provider: undefined,
  tenant: undefined,
};

export function defaultRoleForScope(
  scopeKind: ScopeKind,
  roleOptions: readonly RoleOption[]
): RoleOption | undefined {
  const id = DEFAULT_ROLE[scopeKind];
  if (!id) return undefined;
  return roleOptions.find((r) => r.builtinRoleId === id);
}
